/**
 * The text that goes out with a shared completion card (CelebrationModal's
 * share button). Kept apart from the modal so the counts can be tested
 * without the image export.
 */
import { formatPercent } from '../../utils/percent';
import { countOf } from '../../utils/plural';

export interface ShareCounts {
  domainName?: string;
  pathsCompleted?: number;
  lessonsCompleted?: number;
  averageScore?: number;
  pointsEarned?: number;
  totalPoints?: number;
  daysToComplete?: number;
}

/** Points as the cards print them: with a thousands separator, "1 point" at one. */
function points(n: number | undefined): string {
  const value = n ?? 0;
  return `${value.toLocaleString()} ${value === 1 ? 'point' : 'points'}`;
}

export function celebrationShareText(type: string, data: ShareCounts): string {
  if (type === 'domain') {
    return (
      `I just completed the "${data.domainName}" module on EmpathEase! 🎉🦒\n\n` +
      // "units", as the card's "Units Completed" (the app calls paths Units)
      `${countOf(data.pathsCompleted ?? 0, 'unit')}, ${countOf(data.lessonsCompleted ?? 0, 'lesson')} completed, ${formatPercent(data.averageScore)} average score, ${points(data.pointsEarned)} earned!`
    );
  }
  return (
    `I completed the entire NVC course on EmpathEase! 🏆🦒\n\n` +
    `${countOf(data.lessonsCompleted ?? 0, 'lesson')}, ${points(data.totalPoints)}, ${formatPercent(data.averageScore)} average score in ${countOf(data.daysToComplete ?? 0, 'day')}!`
  );
}
